<section #section style="pointer-events: none" id="home"></section>

<div class="branded-movie-awareness--top-menu">
  <div class="branded-movie-awareness--top-menu--channel">
    <!-- CUSTOM HEADER IMAGES -->
    @if (customHeaderImages()) {
      @for (image of customHeaderImages() || []; track image) {
        @if (!image?.hideOnHeaderLg || !image?.hideOnHeaderSm) {
          @if (image.url && image.externalLink) {
            <a
              class="branded-movie-awareness--top-menu--channel--link"
              [href]="image.externalLink"
              target="_blank"
              rel="noopener noreferrer"
              [class.hiddenOnLg]="image.hideOnHeaderLg"
            >
              <img
                [ngSrc]="image.src"
                [attr.alt]="image.alt"
                [width]="image.width"
                [height]="image.height"
                [class.hiddenOnLg]="image.hideOnHeaderLg"
                [class.hiddenOnSm]="image.hideOnHeaderSm"
              />
            </a>
          } @else if (image.url) {
            <a class="branded-movie-awareness--top-menu--channel--link" [routerLink]="image.url">
              <img
                [ngSrc]="image.src"
                [attr.alt]="image.alt"
                [width]="image.width"
                s
                [height]="image.height"
                [class.hiddenOnLg]="image.hideOnHeaderLg"
                [class.hiddenOnSm]="image.hideOnHeaderSm"
              />
            </a>
          } @else {
            <img
              [ngSrc]="image.src"
              [attr.alt]="image.alt"
              [width]="image.width"
              [height]="image.height"
              [class.hiddenOnLg]="image.hideOnHeaderLg"
              [class.hiddenOnSm]="image.hideOnHeaderSm"
            />
          }
        }
      }
      <!-- END CUSTOM HEADER IMAGES -->
    } @else if (logoExternalLink) {
      <a class="branded-movie-awareness--top-menu--channel--link" [href]="logoExternalLink" target="_blank">
        <img [src]="channelLogoUrl" [attr.alt]="channelName() + ' logo'" />
      </a>
    } @else {
      <a class="branded-movie-awareness--top-menu--channel--link" [routerLink]="!appHasOnlyMovies ? '/' : null">
        <img [src]="channelLogoUrl" [attr.alt]="channelName() + ' logo'" />
      </a>
    }
  </div>

  <div class="branded-movie-awareness--top-menu--mobile-menu no-padding">
    <lib-shared-feature-sidemenu
      linkClass="branded-movie-awareness--top-menu--mobile-menu--link"
      [appendTo]="element"
      closeIconFontSize="var(--sidemenu-icon__fontSize, 28px)"
      closeIconColor="var(--brand-color-contrast-support-contrast)"
    >
      <div class="branded-movie-awareness--sidebar">
        <div class="branded-movie-awareness--sidebar--nav">
          @for (link of sectionsHyperLink(); track link) {
            <a
              [routerLink]="[]"
              [fragment]="link.ref"
              (click)="goToSection(link.ref || '')"
              [attr.data-translate]="link.label"
              >{{ link.label | translate: { placeholder: link.placeholder } }}</a
            >
          }
          @if (movie?.trailerLink) {
            <a class="button not-fill" (click)="playTrailer()" [class.notBrandcolorRedeable]="!isBrandColorReadable()">
              <fa-icon [icon]="faPlay" />&nbsp;<span
                i18n="@@movie.menu.trailer"
                [attr.data-translate]="'movie.menu.trailer'"
                >Trailer</span
              ></a
            >
          }
          @if (status().includes('book-now')) {
            <a
              class="fill button"
              [routerLink]="[routePath, 'book-now']"
              [attr.data-translate]="'movie-template-a.menu.inCinemas'"
              >{{ 'movie-template-a.menu.inCinemas' | translate: { placeholder: 'Book Now' } }}</a
            >
          }
          @if (status().includes('watch-now')) {
            <a
              class="fill button"
              [routerLink]="[routePath, 'watch-now']"
              [attr.data-translate]="'movie-template-a.menu.watchAtHome'"
              >{{ 'movie-template-a.menu.watchAtHome' | translate: { placeholder: 'Watch at Home' } }}</a
            >
          }
          @if (hasAssets) {
            <div class="branded-movie-awareness--sidebar--assets">
              <ush-assets-locker-link
                [movie]="movie"
                [hideLabel]="true"
                [label]="ASSETSLOCKER_LABEL"
                [labelButton]="ASSETSLOCKER_LABEL_BUTTON"
              />
            </div>
          }
        </div>

        @if (movie) {
          <div class="branded-movie-awareness--sidebar--sharing">
            @defer {
              <ush-movie-tell-friends [movie]="movie!" />
            }
          </div>
        }

        <div class="branded-movie-awareness--sidebar--channel">
          <!-- CUSTOM HEADER IMAGES -->
          @if (customHeaderImages()) {
            @for (image of customHeaderImages() || []; track image) {
              @if (!image?.hideOnSideMenu) {
                @if (image.url && image.externalLink) {
                  <a
                    class="branded-movie-awareness--top-menu--channel--link"
                    [href]="image.externalLink"
                    target="_blank"
                    rel="noopener noreferrer"
                    [class.hiddenOnLg]="image.hideOnHeaderLg"
                  >
                    <img
                      [ngSrc]="image.src"
                      [attr.alt]="image.alt"
                      [width]="image.width"
                      [height]="image.height"
                      [class.hiddenOnLg]="image.hideOnHeaderLg"
                      [class.hiddenOnSm]="image.hideOnHeaderSm"
                    />
                  </a>
                } @else if (image.url) {
                  <a class="branded-movie-awareness--top-menu--channel--link" [routerLink]="image.url">
                    <img
                      [ngSrc]="image.src"
                      [attr.alt]="image.alt"
                      [width]="image.width"
                      s
                      [height]="image.height"
                      [class.hiddenOnLg]="image.hideOnHeaderLg"
                      [class.hiddenOnSm]="image.hideOnHeaderSm"
                    />
                  </a>
                } @else {
                  <img
                    [ngSrc]="image.src"
                    [attr.alt]="image.alt"
                    [width]="image.width"
                    [height]="image.height"
                    [class.hiddenOnLg]="image.hideOnHeaderLg"
                    [class.hiddenOnSm]="image.hideOnHeaderSm"
                  />
                }
              }
            }
            <!-- END CUSTOM HEADER IMAGES -->
          } @else {
            <a class="branded-movie-awareness--sidebar--channel--link" [routerLink]="!appHasOnlyMovies ? '/' : null">
              <img [src]="channelLogoUrl" [height]="80" [attr.alt]="channelName + ' logo'" />
            </a>
          }
        </div>
      </div>
    </lib-shared-feature-sidemenu>
  </div>
</div>

@if (movie) {
  <div class="branded-movie-awareness--sharing">
    <ush-movie-tell-friends [movie]="movie!" ngSkipHydration />
  </div>

  <div
    #brandedMovie
    class="branded-movie"
    [class.landing-fill-screen]="landingFillScreen()"
    [ngStyle]="brandedMovieStyle()"
  >
    <div class="branded-movie-awareness--head">
      <!--
      TODO: Hability to setup dynamic height of the container image. WIP
      [ushBackgroundImageContainerFit]="movieAwarenessBackgroundImageFit"
       -->
      <div class="branded-movie-awareness--background">
        <!-- <ush-video #video [content]="movie" [embed]="true" [autoplay]="true" [controls]="false" [mute]="true" /> -->
        <img [ngSrc]="movie!.tilePhotoUrl!" fill priority [alt]="movie?.title + ' tile image'" priority="true" />
      </div>
    </div>
    <div class="branded-movie-awareness--body">
      <div class="branded-movie--auxiliar-menu" [class.visible]="auxiliarMenuVisible()">
        <a class="branded-movie-awareness--logo--wrapper" (click)="goToSection('landing')" *ngIf="!hideLogoTitle">
          @if (movie?.logoUrl) {
            <div class="branded-movie-awareness--logo--wrapper-support">
              <img
                class="branded-movie-awareness--movie--logo"
                [ngSrc]="movie!.logoUrl!"
                sizes="(max-width:530px) 90vw, (max-width:1000px) 50vw, 30vw"
                height="150"
                width="450"
                style="height: auto; max-width: 90vw"
                priority="true"
                [alt]="'video thumbnail image of ' + movie?.title"
              />
              @if (!hideReleaseMessage) {
                <p class="branded-movie-awareness--movie--releaseMessage">
                  {{ movie?.releaseMessage || 'release Message' }}
                </p>
              }
            </div>
          }
        </a>

        <div class="branded-movie-awareness--menu">
          <div class="branded-movie-awareness--menu--links">
            @for (link of sectionsHyperLink(); track link) {
              <a
                [routerLink]="[]"
                [fragment]="link.ref"
                (click)="goToSection(link.ref!)"
                [attr.data-translate]="link.label"
                >{{ link.label | translate: { placeholder: link.placeholder } }}</a
              >
            }
          </div>
          <div class="branded-movie-awareness--menu--controls">
            @if (movie?.trailerLink) {
              <a
                class="button not-fill"
                (click)="playTrailer()"
                [class.notBrandcolorRedeable]="!isBrandColorReadable()"
              >
                <fa-icon [icon]="faPlay" />&nbsp;<span [attr.data-translate]="'movie.menu.trailer'">
                  {{ 'movie.menu.trailer' | translate }}</span
                >
              </a>
            }
            @if (status().includes('book-now')) {
              <a
                class="fill button"
                [routerLink]="[routePath, 'book-now']"
                [attr.data-translate]="'movie-template-a.menu.inCinemas'"
                >{{ 'movie-template-a.menu.inCinemas' | translate: { placeholder: 'Book Now' } }}</a
              >
            }
            @if (status().includes('watch-now')) {
              <a
                class="fill button"
                [routerLink]="[routePath, 'watch-now']"
                [attr.data-translate]="'movie-template-a.menu.watchAtHome'"
                >{{ 'movie-template-a.menu.watchAtHome' | translate: { placeholder: 'Watch at Home' } }}</a
              >
            }

            @if (status().includes('calendar')) {
              <div class="branded-movie-awareness--menu--controls--calendar">
                <lib-shared-feature-calendar-button
                  [subject]="movie?.title + ' release'"
                  [text]="movieShowtimeLink"
                  [date]="releaseDate()"
                  direction="down"
                  [trackingEvent]="trackingEventCalendar"
                />
              </div>
            }

            @if (hasAssets) {
              <div class="branded-movie-awareness--menu--controls--assets">
                <ush-assets-locker-link
                  [movie]="movie"
                  [hideLabel]="true"
                  [label]="ASSETSLOCKER_LABEL"
                  [labelButton]="ASSETSLOCKER_LABEL_BUTTON"
                />
              </div>
            }
          </div>
        </div>
      </div>

      <section #section id="landing" class="branded-movie-awarness" intersectionObserve intersectionRef="section">
        <div
          class="branded-movie-awareness--wrapper"
          intersectionObserve
          intersectionAnimation="slide-up"
          intesetionAnimationMobile="slide-up"
          intersectionAnimationOnce="false"
          intersectionRef="menu"
          data-debug
        >
          <div
            class="branded-movie-awareness--logo"
            [ngClass]="{ 'no-release-message': !movie?.releaseMessage }"
            *ngIf="!hideLogoTitle && !hideTitleText"
          >
            <div
              class="branded-movie-awareness--logo--wrapper"
              intersectionObserve
              intersectionAnimation="slide-up"
              intesetionAnimationMobile="slide-up"
              intersectionAnimationOnce="false"
            >
              @if (movie?.logoUrl && !hideLogoTitle) {
                <div class="branded-movie-awareness--logo--wrapper-support">
                  <img
                    class="branded-movie-awareness--movie--logo"
                    [ngSrc]="movie!.logoUrl!"
                    sizes="(max-width:1200px) 90vw, 20vw"
                    height="150"
                    width="450"
                    priority="true"
                    [alt]="'video thumbnail image of ' + movie?.title"
                  />
                  <!-- Support element used in case that attachReleaseMessageToLogo is enabled -->
                  @if (!hideReleaseMessage && attachReleaseMessageToLogo) {
                    <p class="branded-movie-awareness--movie--releaseMessage">
                      {{ movie?.releaseMessage || 'release Message' }}
                    </p>
                  }
                </div>
              } @else if (!hideTitleText) {
                <h2 class="branded-movie-awareness--movie--title">{{ movie?.title }}</h2>
              }
            </div>
          </div>

          @if (!hideReleaseMessage && movie?.releaseMessage) {
            <div class="branded-movie-awareness--movie">
              <p class="branded-movie-awareness--movie--releaseMessage">
                {{ movie?.releaseMessage || 'release Message' }}
              </p>
            </div>
          }

          <div class="branded-movie-awareness--menu">
            <div class="branded-movie-awareness--menu--links">
              @for (link of sectionsHyperLink(); track link) {
                <a
                  [routerLink]="[]"
                  [fragment]="link.ref"
                  (click)="goToSection(link.ref!)"
                  [attr.data-translate]="link.label"
                  >{{ link.label | translate: { placeholder: link.placeholder } }}</a
                >
              }
            </div>
            <div class="branded-movie-awareness--menu--controls">
              @if (movie?.trailerLink) {
                <a
                  class="button not-fill"
                  (click)="playTrailer()"
                  [class.notBrandcolorRedeable]="!isBrandColorReadable()"
                >
                  <fa-icon [icon]="faPlay" />&nbsp;<span [attr.data-translate]="'movie.menu.trailer'">
                    {{ 'movie.menu.trailer' | translate }}</span
                  >
                </a>
              }
              @if (status().includes('book-now')) {
                <a
                  class="fill button"
                  [routerLink]="[routePath, 'book-now']"
                  [attr.data-translate]="'movie-template-a.menu.inCinemas'"
                  >{{ 'movie-template-a.menu.inCinemas' | translate: { placeholder: 'Book Now' } }}</a
                >
              }
              @if (status().includes('watch-now')) {
                <a
                  class="fill button"
                  [routerLink]="[routePath, 'watch-now']"
                  i18n="@@movie-template-a.menu.watchAtHome"
                  [attr.data-translate]="'movie-template-a.menu.watchAtHome'"
                  >{{ 'movie-template-a.menu.watchAtHome' | translate: { placeholder: 'Watch at Home' } }}</a
                >
              }

              @if (status().includes('calendar')) {
                <div class="branded-movie-awareness--menu--controls--calendar">
                  <lib-shared-feature-calendar-button
                    [subject]="movie?.title + ' release'"
                    [text]="movieShowtimeLink"
                    [date]="releaseDate()"
                    direction="up"
                    [trackingEvent]="trackingEventCalendar"
                  />
                </div>
              }

              @if (hasAssets) {
                <div class="branded-movie-awareness--menu--links--assets">
                  <ush-assets-locker-link
                    [movie]="movie"
                    [hideLabel]="true"
                    [label]="ASSETSLOCKER_LABEL"
                    [labelButton]="ASSETSLOCKER_LABEL_BUTTON"
                  />
                </div>
              }
            </div>
          </div>
          <div class="branded-movie-awareness--wrapper-background-image-wrapper" [class.gradient]="!disableGradient">
            <img
              class="branded-movie-awareness--wrapper-background-image"
              [ngSrc]="movie!.tilePhotoUrl!"
              fill
              priority
              [alt]="movie?.title + ' tile image'"
            />
            <img
              class="branded-movie-awareness--wrapper-background-image-fill"
              [ngSrc]="movie!.tilePhotoUrl!"
              fill
              priority
              [alt]="movie?.title + ' tile image'"
            />
          </div>
        </div>
      </section>

      <section
        #section
        #storyline
        id="storyline"
        class="branded-movie-awareness--storyline"
        [ngClass]="sectionStorylineVisibleClass()"
        intersectionObserve
        intersectionRef="section"
      >
        <div class="branded-movie-awareness--storyline--wrapper">
          <div
            class="branded-movie-awareness--storyline--portrait"
            intersectionObserve
            intersectionAnimation="slide-left"
            intesetionAnimationMobile="slide-up"
            intersectionAnimationOnce="false"
          >
            <img
              [ngSrc]="movie!.portraitPhotoUrl!"
              width="360"
              height="540"
              priority="true"
              [alt]="movie!.title! + ' portrait'"
            />
          </div>
          @if (movie?.socialNetworks) {
            <div
              class="branded-movie-awareness--storyline--social-links"
              [class.notBrandcolorRedeable]="!isBrandColorReadable()"
            >
              <h4 i18n="public.footer.social.link" [attr.data-translate]="'public.footer.social.link'">Follow</h4>
              <ush-social-links [socialNetworks]="movie?.socialNetworks || []" />
            </div>
          }
          <div
            class="branded-movie-awareness--storyline--content"
            intersectionObserve
            intersectionAnimation="slide-right"
            intersectionRef="no-threshold"
            intersectionAnimationOnce="false"
          >
            <div class="branded-movie-awareness--storyline--content--wrapper">
              <h2
                class="branded-movie-awareness--storyline--content--title"
                i18n="@@movie.menu.synopsis"
                [attr.data-translate]="'movie.menu.synopsis'"
              >
                Summary
              </h2>
              <div
                #descriptionContainer
                class="branded-movie-awareness--storyline--content--description"
                [innerHTML]="movie?.description | safe: 'html'"
              ></div>
              <div class="branded-movie-awareness--storyline--content--credits">
                <ush-movie-credits [movie]="movie!" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        #section
        id="metadata"
        class="branded-movie-awareness--metadata"
        intersectionObserve
        intersectionRef="section"
      >
        <div class="branded-movie-awareness--metadata--wrapper">
          <div
            class="branded-movie-awareness--metadata--content"
            intersectionObserve
            intersectionAnimation="slide-left"
            intesetionAnimationMobile="slide-left"
            intersectionAnimationOnce="false"
          >
            <div class="branded-movie-awareness--metadata--content--wrapper">
              <div class="branded-movie-awareness--metadata--content--info">
                <ush-movie-more-information
                  [movie]="movie"
                  [showPortrait]="false"
                  [disableImdb]="disableImdb"
                  [disableTmdb]="disableTmdb"
                />
              </div>
            </div>
          </div>

          <div
            class="branded-movie-awareness--metadata--portrait"
            intersectionObserve
            intersectionAnimation="slide-right"
            intesetionAnimationMobile="slide-up"
            intersectionAnimationOnce="false"
          >
            <div class="branded-movie-awareness--metadata--portrait--wrapper">
              <img
                [ngSrc]="movie!.portraitPhotoUrl!"
                width="360"
                height="540"
                priority="true"
                [alt]="movie!.title! + ' portrait'"
              />
            </div>
          </div>

          @if (movie?.socialNetworks) {
            <div
              class="branded-movie-awareness--metadata--social-links"
              intersectionObserve
              intersectionAnimation="none"
              intesetionAnimationMobile="slide-up"
              intersectionAnimationOnce="false"
            >
              <h4 i18n="@@public.footer.social.link" [attr.data-translate]="'public.footer.social.link'">Follow</h4>
              <ush-social-links [socialNetworks]="movie?.socialNetworks || []" />
            </div>
          }
        </div>
      </section>

      <!-- @if (movie?.newsPosts?.length || 0 > 0) {
        <section #section #news class="branded-movie-awareness--news" intersectionObserve intersectionRef="section">
          <community-feature-news-carousel [news]="movie!.newsPosts!" />
        </section>
      } -->

      @if (movie?.movieImages) {
        <section
          #section
          #gallery
          id="gallery"
          class="branded-movie-awareness--gallery"
          [class.notBrandcolorRedeable]="!isBrandColorReadable()"
          intersectionObserve
          intersectionRef="section"
        >
          <div class="branded-movie-awareness--gallery--wrapper">
            @defer (on viewport; on immediate) {
              <feature-gallery-carousel
                [images]="movie?.movieImages || []"
                [imageOrientation]="'landscape'"
                [slidesPerView]="gallerySlidesPerView"
                [arrowTemplate]="6"
                [autoplay]="true"
              />
            } @placeholder {
              <div></div>
            }
          </div>
        </section>
      }

      @if (movie?.copyrightImageUrl) {
        <section class="branded-movie-awareness--billing">
          <div class="branded-movie-awareness--billing--content">
            <img [src]="movie!.copyrightImageUrl! | img" [alt]="'billing ' + movie?.trTitle" />
          </div>
        </section>
      }
    </div>
  </div>
}
<div class="footer-container">
  <div #footerWrapper class="footer-container--wrapper"></div>
</div>

<style>
  ush-header {
    display: none;
  }
</style>
